import { createSlice } from "@reduxjs/toolkit";

import { fetchCurrencies, updateCurrencySettings } from "./actions";
import { FALLBACK_DEFAULT_CURRENCY } from "./constants";

export const initialState = {
  defaultCurrency: FALLBACK_DEFAULT_CURRENCY,
  rates: [],
  supportedCurrencies: [],
  loaded: false,
  isLoading: false,
  error: null,
};

const DEFAULT_ERROR = "Failed to load currency settings";

const applySettings = (state, action) => {
  state.isLoading = false;
  state.loaded = true;
  state.defaultCurrency =
    action.payload?.defaultCurrency ?? FALLBACK_DEFAULT_CURRENCY;
  state.rates = action.payload?.rates ?? [];
  state.supportedCurrencies = action.payload?.supportedCurrencies ?? [];
};

const markPending = (state) => {
  state.isLoading = true;
  state.error = null;
};

const markRejected = (state, action) => {
  state.isLoading = false;
  state.error = action.error?.message ?? DEFAULT_ERROR;
};

const markSaveRejected = (state, action) => {
  state.isLoading = false;
  state.error =
    action.payload?.message ?? action.error?.message ?? DEFAULT_ERROR;
};

const currencySlice = createSlice({
  name: "currency",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrencies.pending, markPending)
      .addCase(fetchCurrencies.fulfilled, applySettings)
      .addCase(fetchCurrencies.rejected, markRejected)
      .addCase(updateCurrencySettings.pending, markPending)
      .addCase(updateCurrencySettings.fulfilled, applySettings)
      .addCase(updateCurrencySettings.rejected, markSaveRejected);
  },
});

export default currencySlice.reducer;
